













































































































import Vue from 'vue';
import { APIClient } from '../../libs/ApiClient';
import UploadButton from 'vuetify-upload-button';
import NavbarComp from '../modules/NavbarComp.vue';
import FooterComp from '../modules/FooterComp.vue';
import LoadingDialogComp from '../modules/LoadingDialogComp.vue';
import GeneralDialogComp from '../modules/GeneralDialogComp.vue';
import { ErrorUtils } from '../../libs/ErrorUtils';
import router from '@/router';
import colors from 'vuetify/es5/util/colors';

export default Vue.extend({
  name: 'Upload',
  data() {
    return {
      valid: true,
      img_create_apostille: require('../../assets/create_apostille.png'),
      img_service_select: require('../../assets/service_select.png'),
      deleteKey: '',
      deleteKeyRules: [
        (v: string) => !!v || this.$t('common.validateDeleteKey').toString(),
      ],
      file: new Blob(),
      filename: '',
      fileRules: [
        (v: string) => !!v || this.$t('add.validateSelectFile').toString(),
      ],
      isLoading: false,
      loadingMessage: this.$t('add.uploading').toString(),
      isShowGeneralDialog: false,
      generalDialogMessage: '',
      generalDialogEmit: 'reset',
      isShowToDetailDialog: false,
      toDetailDialogMessage: '',
      toDetailDialogEmit: 'toTopReset',
      toDetailUrl: '',
    };
  },
  components: {
    NavbarComp,
    FooterComp,
    UploadButton,
    LoadingDialogComp,
    GeneralDialogComp,
  },
  methods: {
    async uploadApostille() {
      const form: any = this.$refs.form;
      if (!form.validate()) {
        return;
      }

      try {
        this.isLoading = true;
        const file: any = await this.fileReaderPromise();
        const res = await APIClient.uploadApostille(file, this.deleteKey, this.filename);
        this.isLoading = false;
        this.toDetailUrl = `/detail/${res.txHash}`;
        this.showToDetailDialog(this.$t('add.uploadDone').toString());
      } catch (err) {
        this.isLoading = false;
        this.showDialog(await ErrorUtils.getErrorMessageForUpload(err.response.data.code));
      }
    },
    selectedFile(file: any) {
      this.file = file;
      this.filename = file.name;
    },
    validateFileExt(filename: string) {

    },
    fileReaderPromise() {
      return new Promise((resolve: any, reject: any) => {
        const fileReader = new FileReader();
        fileReader.readAsBinaryString(this.file);
        fileReader.onload = (event: any) => {
          resolve(event.target!.result);
        };
      });
    },
    showDialog(message: string) {
      this.generalDialogMessage = message;
      this.isShowGeneralDialog = true;
    },
    resetDialog() {
      this.isShowGeneralDialog = false;
      this.generalDialogMessage = '';
    },
    showToDetailDialog(message: string) {
      this.isShowToDetailDialog = true;
      this.toDetailDialogMessage = message;
    },
    resetToDetailDialog() {
      this.isShowToDetailDialog = false;
      router.push(this.toDetailUrl);
    },
  },
});
